// extracted by mini-css-extract-plugin
export default {"wrapper":"input-date-simple_wrapper__K5M7k","disabled":"input-date-simple_disabled__6YDk8","input":"input-date-simple_input__k34Wy"};